module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/_library.js
// module id = 186
// module chunks = 0